import moment from 'moment';
import { createPage, createFlow } from '../utils';
import { MALE } from '../../gender';
import i18n from '../../../plugins/i18n';
import { REPEAT } from '../variables';
import { APPOINTMENT_TYPES } from '../../appointment';
import { NODE_ENV } from '../../env';
import { PRETTY_DATE_FORMAT, TIME_FORMAT } from '../../moment';

const RegisterIntroduce = createPage({
  name: 'RegisterIntroduce',
  nextPage: 'RegisterInform',
  options: {
    pageConfig: {
      healthCardExpiryOptional: true,
      isAddressOptional: true,
      isEmailOptional: true,
      showGender: true,
      showEmail: true,
      showAddress: true,
      pageTitle: 'Patient Information',
      patientData: {
        gender: MALE,
      },
    },
  },
});
const RegisterInform = createPage({
  name: 'RegisterInform',
  nextPage: 'RegisterSchedule',
  options: {
    pageConfig: {
      init: (store, route) => {
        store.commit('setRegistration', {
          // Set appt type to 'video'
          appointmentType: APPOINTMENT_TYPES.inPerson,
        });
        // Set default answer to three questions to 'false'
        store.commit('addDefaultPatientNotes', {
          basicNotes: [
            'Has had annual checkup?: false',
            'Specialist Requested: false',
            'Do you have a family physician?: false',
          ],
        });

        const availableEmployees =
          route.query?.e?.split('-') ||
          (store?.state?.registration?.employeeId && [store?.state?.registration?.employeeId]) ||
          [];

        if (availableEmployees?.length) store.commit('setRegistration', { availableEmployees });
      },
      enabledAppointmentTypes: [APPOINTMENT_TYPES.video, APPOINTMENT_TYPES.inPerson],
      appointmentReasons: [
        'Abnormal ECG',
        'ACS/Post Myocardial Infarct',
        'Arrhythmia (specify below)',
        'Atrial Fibrillation - New Onset',
        'Atrial Fibrillation - Reassess',
        'Chest Pain',
        'Congestive Heart Failure',
        'Coronary Artery Disease',
        'Dyspnea/SOBOE',
        'Endocarditis',
        'Hypertension',
        'Murmur',
        'Pacemaker/ICD assessment',
        'Palpitations',
        'Pericardial Disease',
        'Post Cardiac Bypass',
        'Prosthetic Heart Valve (specify position/type/date of implant below, if known)',
        'Syncope/Presyncope',
        'TIA/Stroke/Embolic Event',
        'Valvular Disease (specify below)',
      ],
      isReasonForVisitFixed: false,
      reasonForVisit: '',
      pageTitle: 'Additional Patient Information',
      pageSubtitle: 'Please provide more information about the appointment to be booked',
      form: {
        questionOne: {
          variableName: 'annualCheckup',
          displayText: null,
          noteLabel: 'Has had annual checkup?',
          infoText: null,
          show: true,
          value: false,
        },
        questionTwo: {
          variableName: 'seeSpecialist',

          displayText: null,
          noteLabel: 'Specialist Requested',
          show: true,
          value: null,
        },
        questionThree: {
          variableName: 'hasFamilyPhysician',
          displayText: null,
          noteLabel: 'Do you have a family physician?',
          infoText: null,
          show: true,
          value: false,
        },
      },
    },
  },
});

const RegisterSchedule = createPage({
  name: 'RegisterSchedule',
  nextPage: 'RegisterComplete',
  options: {
    pageConfig: {
      bufferMinutesV2: moment().add(1, 'day').startOf('day').diff(moment(), 'minutes'),
      init: (store) => {
        if (NODE_ENV === 'production') {
          store.commit('setRegistration', {
            availableEmployees: ['m1Wy7pN7o1awK5a8VRw2e3VH4kJ3'],
          });
        }
      },
      allowAppointmentRequest: false,
      appointmentDuration: 15,
      eventColor: '#ffd7cf',
      hideProviderName: true,
      pageTitle: 'Please select an appointment time',
      pageSubtitle: ' ',
    },
  },
});

const RegisterComplete = createPage({
  name: 'RegisterComplete',
  nextPage: 'RegisterFileUpload',
  options: {
    pageConfig: {
      checkForExistingUser: true,
      buttonText: i18n.t('main.continue'),
      cardText: i18n.t('registration.registerComplete.defaultFlow.cardText'),
      cardTitle: i18n.t('registration.registerComplete.trt.cardTitle'),
      clickToContinue: false,
      isEndOfRegistration: false,
    },
  },
});

const RegisterFileUpload = createPage({
  name: 'RegisterFileUpload',
  nextPage: 'RegisterLogout',
  options: {
    clearHistory: true,
    pageConfig: {
      init: (store, vars, vm) => {
        // eslint-disable-next-line no-param-reassign
        vm.customModalSubtitle = `Patient: ${i18n.t(
          'format.fullName',
          store.state.registration.patientData
        )}
        Provider: ${store.state.registration.employeeName}
        Appointment: ${store.state.registration.appointmentTime.format(
          `${PRETTY_DATE_FORMAT} [at] ${TIME_FORMAT}`
        )}
      `;
      },
      isEndOfRegistration: true,
      leadLocations: [],
      pageTitle: 'Please upload relevant medical file(s)',
      maxFiles: 25,
    },
  },
});

const RegisterLogout = createPage({
  name: 'RegisterLogout',
  nextPage: REPEAT,
  options: {
    clearHistory: true,
  },
});

const medishare = createFlow({
  landing: 'RegisterIntroduce',

  onError: 'RegisterIntroduce',
  flow: {
    RegisterIntroduce,
    RegisterInform,
    RegisterSchedule,
    RegisterComplete,
    RegisterFileUpload,
    RegisterLogout,
  },
});

export default medishare;
